import { render, staticRenderFns } from "./LayoutScreen.vue?vue&type=template&id=ce061ddc&scoped=true&"
import script from "./LayoutScreen.vue?vue&type=script&lang=js&"
export * from "./LayoutScreen.vue?vue&type=script&lang=js&"
import style0 from "./LayoutScreen.vue?vue&type=style&index=0&id=ce061ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce061ddc",
  null
  
)

export default component.exports